import { Label, Typography } from "@king-ict/eupisi-ui/components";
import { Row, Col } from "react-bootstrap";

import styles from "./FormCard.module.scss";

export interface FormCardProps {
  children?: any;
  cardTitle?: string;
  labelStatus?: {
    color?: "primary" | "success" | "warning" | "danger" | "noted-2";
    name: string;
  };
  className?: string;
}

export const FormCard = ({
  children,
  cardTitle,
  labelStatus,
  className,
}: FormCardProps) => {
  const renderCardTitle = () => {
    if (!cardTitle) return;

    return (
      <Row>
        <Col md={10}>
          <Typography variant="smallHeading" className="pt-2">
            {cardTitle}
          </Typography>
        </Col>
        <Col md={2}>
          {!labelStatus || labelStatus.name === "" || (
            <Label color={labelStatus?.color} fullWidth={false}>
              {labelStatus?.name}
            </Label>
          )}
        </Col>
      </Row>
    );
  };

  return (
    <div className={`${styles.formcard} ${className}`}>
      {renderCardTitle()}
      <div>{children}</div>
    </div>
  );
};
